import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "product-gallery" }
const _hoisted_2 = {
  key: 0,
  class: "product-gallery__thumbs"
}
const _hoisted_3 = { class: "product-gallery__thumb-wrapper" }
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "product-gallery__video-icon"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "product-gallery__image-wrapper" }
const _hoisted_9 = ["srcset"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "gallery-item__plus" }
const _hoisted_12 = {
  key: 0,
  class: "product-gallery__pagination js-product-slider-pagination"
}
const _hoisted_13 = {
  key: 2,
  class: "product-gallery__placeholder"
}
const _hoisted_14 = { class: "ds-aspect-ratio ds-aspect-ratio--appearance_filled ds-aspect-ratio--ratio_4x4" }
const _hoisted_15 = { class: "ds-aspect-ratio__body" }
const _hoisted_16 = { class: "image-wrapper" }
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_video = _resolveComponent("icon-video")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_icon_play = _resolveComponent("icon-play")!
  const _component_icon_plus_circle = _resolveComponent("icon-plus-circle")!
  const _component_modal_trigger = _resolveComponent("modal-trigger")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.preparedImages.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_swiper, {
            onSwiper: $setup.setThumbsSwiper,
            modules: $setup.modules,
            loop: false,
            autoHeight: false,
            spaceBetween: 6,
            speed: 500,
            slidesPerView: 5,
            breakpoints: $setup.breakpoints,
            direction: "vertical"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.preparedImages, (item, index) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _createElementVNode("picture", _hoisted_3, [
                      (item.image_url_sized.webp)
                        ? (_openBlock(), _createElementBlock("source", {
                            key: 0,
                            type: "image/webp",
                            srcset: item.image_url_sized.webp
                          }, null, 8, _hoisted_4))
                        : _createCommentVNode("", true),
                      _createElementVNode("img", {
                        class: "product-gallery__image",
                        src: item.image_url_sized.base
                      }, null, 8, _hoisted_5),
                      (item.video_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_icon_video)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    ($setup.preparedImages.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["product-gallery__main", { 'is-single': $setup.preparedImages.length === 1 }])
        }, [
          _createVNode(_component_swiper, {
            modules: $setup.modules,
            loop: false,
            spaceBetween: 12,
            speed: 500,
            slidesPerView: 1,
            autoplay: { delay: 5000 },
            thumbs: { swiper: $setup.thumbsSwiper, autoScrollOffset: 1 },
            pagination: $props.needPagination ? { clickable: true, el: '.js-product-slider-pagination' } : false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.preparedImages, (item, index) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_modal_trigger, {
                      component: "Modals/Common/ModalLightbox",
                      classes: ['modal--size_full'],
                      images: $setup.preparedImages,
                      "initial-slide": index
                    }, {
                      default: _withCtx(({ open }) => [
                        _createElementVNode("div", {
                          class: "gallery-item gallery-item--variant_spaced",
                          onClick: _withModifiers(open, ["prevent"])
                        }, [
                          _createElementVNode("picture", _hoisted_8, [
                            (item.image_url_sized.webp)
                              ? (_openBlock(), _createElementBlock("source", {
                                  key: 0,
                                  type: "image/webp",
                                  srcset: item.image_url_sized.webp
                                }, null, 8, _hoisted_9))
                              : _createCommentVNode("", true),
                            _createElementVNode("img", {
                              class: "product-gallery__main-image",
                              src: item.image_url_sized.base
                            }, null, 8, _hoisted_10)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            (item.video_url)
                              ? (_openBlock(), _createBlock(_component_icon_play, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_icon_plus_circle, { key: 1 }))
                          ])
                        ], 8, _hoisted_7)
                      ]),
                      _: 2
                    }, 1032, ["images", "initial-slide"])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          }, 8, ["thumbs", "pagination"]),
          ($props.needPagination)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (!$setup.preparedImages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("picture", _hoisted_16, [
                _createElementVNode("img", {
                  class: "image-wrapper__item image-wrapper__item--fit",
                  src: $setup.placeholderImage
                }, null, 8, _hoisted_17)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}